/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Lost_Gone_Access_WarnInputs */

const en_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`After the current billing period, you will no longer have access to ${i?.displayName} or its benefits:`)
};

const id_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Setelah periode penagihan saat ini, Anda tidak lagi memiliki akses ke ${i?.displayName} atau manfaatnya:`)
};

const ms_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selepas tempoh pengebilan sekarang ini, anda tiada lagi akses kepada ${i?.displayName} atau manfaatnya:`)
};

const ca_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un cop finalitzat el període de facturació actual, ja no tindràs accés a ${i?.displayName} o els seus avantatges:`)
};

const cs_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Po skončení aktuálního zúčtovacího období již nebudete mít přístup k ${i?.displayName} ani k jeho výhodám:`)
};

const da_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Efter den aktuelle faktureringsperiode vil du ikke længere have adgang til ${i?.displayName} eller dens fordele:`)
};

const de_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nach dem aktuellen Abrechnungszeitraum hast du keinen Zugriff mehr auf ${i?.displayName} oder dessen Vorteile:`)
};

const et_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pärast käesolevat arveldusperioodi ei ole teil enam juurdepääsu teenusele ${i?.displayName} ega selle soodustustele:`)
};

const es_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Después del periodo de facturación actual, no tendrás acceso a ${i?.displayName} o sus beneficios:`)
};

const fr_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Après la période de facturation en cours, vous n’aurez plus accès à ${i?.displayName} ni à ses fonctionnalités :`)
};

const hr_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nakon tekućeg obračunskog razdoblja više nećete imati pristup funkcionalnosti ${i?.displayName} ni njezinim benefitima:`)
};

const it_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Al termine del periodo di fatturazione attuale, non avrai più accesso a ${i?.displayName} o ai suoi vantaggi:`)
};

const lv_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pēc pašreizējā norēķinu perioda beigām jums vairs nebūs piekļuves ${i?.displayName} un tā priekšrocībām:`)
};

const lt_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pasibaigus dabartiniam atsiskaitymo laikotarpiui, nebeturėsite prieigos prie ${i?.displayName} ir jo privilegijų:`)
};

const hu_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Az aktuális számlázási időszak után Ön már nem fér hozzá a ${i?.displayName} oldalhoz és annak előnyeihez:`)
};

const nl_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na de huidige factureringsperiode heb je geen toegang meer tot ${i?.displayName} en de bijbehorende voordelen:`)
};

const nb_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etter den inneværende betalingsperioden vil du miste tilgangen til ${i?.displayName} og fordelene som følger med:`)
};

const pl_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Po zakończeniu bieżącego okresu rozliczeniowego nie będziesz już mieć dostępu do ${i?.displayName} ani powiązanych korzyści:`)
};

const pt_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Após o período de cobrança atual, você não terá mais acesso ao ${i?.displayName} ou aos seus benefícios:`)
};

const ro_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`După perioada de facturare curentă, nu vei mai avea acces la ${i?.displayName} sau la beneficiile acestuia:`)
};

const sk_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Po skončení aktuálneho zúčtovacieho obdobia už nebudete mať prístup k službe ${i?.displayName} ani k jej výhodám:`)
};

const sl_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Po trenutnem obračunskem obdobju ne bos več imeli dostopa do »${i?.displayName}« ali ugodnosti:`)
};

const fi_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nykyisen laskutusjakson jälkeen sinulla ei ole enää pääsyä kohteeseen ${i?.displayName} tai sen etuihin:`)
};

const sv_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Efter den aktuella faktureringsperioden kommer du inte längre att ha tillgång till ${i?.displayName} eller dess förmåner:`)
};

const vi_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sau khi kết thúc kỳ thanh toán hiện tại, bạn sẽ không còn quyền truy cập ${i?.displayName} hoặc các lợi ích:`)
};

const tr_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mevcut fatura döneminden sonra, artık ${i?.displayName} hesabına veya avantajlarına erişiminiz olmayacaktır:`)
};

const el_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Μετά την τρέχουσα περίοδο χρέωσης, δεν θα έχετε πλέον πρόσβαση στο ${i?.displayName} ή στις παροχές του:`)
};

const bg_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`След изтичане на текущия период на фактуриране вече няма да имаш достъп до ${i?.displayName} и ползите от него:`)
};

const ru_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`По истечении текущего периода выставления счетов доступ к ${i?.displayName} или его преимуществам:`)
};

const sr_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Након текућег обрачунског периода, нећете више имати приступ функцији ${i?.displayName} ни њеним погодностима:`)
};

const uk_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`По завершенню цього платіжного циклу доступ до ${i?.displayName} та його функцій буде втрачено:`)
};

const ka_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`მიმდინარე გადახდის პერიოდის შემდეგ, თქვენ აღარ გექნებათ წვდომა ${i?.displayName}-ზე ან მის უპირატესობებზე:`)
};

const hi_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`करंट बिलिंग पीरियड के बाद, आपको ${i?.displayName} या इसके लाभों तक पहुंच नहीं मिलेगी:`)
};

const th_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`หลังจากรอบการเรียกเก็บเงินปัจจุบัน คุณจะไม่สามารถเข้าถึง ${i?.displayName} หรือสิทธิประโยชน์ใดๆ ได้อีกต่อไป:`)
};

const ko_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`현재 청구 기간이 지나면 ${i?.displayName} 또는 해당 혜택에 더 이상 액세스할 수 없습니다.`)
};

const zh_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`当前账单期结束后，您将无法再访问 ${i?.displayName} 或享受其提供的权益：`)
};

const zh_tw_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在目前的帳單週期之後，您將無法再使用 ${i?.displayName} 或其福利：`)
};

const ja_lost_gone_access_warn = /** @type {(inputs: Lost_Gone_Access_WarnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`現在の請求期間を過ぎると、 ${i?.displayName} やその特典をご利用いただけなくなります：`)
};

/**
* | output |
* | --- |
* | "After the current billing period, you will no longer have access to {displayName} or its benefits:" |
*
* @param {Lost_Gone_Access_WarnInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const lost_gone_access_warn = /** @type {((inputs: Lost_Gone_Access_WarnInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lost_Gone_Access_WarnInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lost_gone_access_warn(inputs)
	if (locale === "ms") return ms_lost_gone_access_warn(inputs)
	if (locale === "ca") return ca_lost_gone_access_warn(inputs)
	if (locale === "cs") return cs_lost_gone_access_warn(inputs)
	if (locale === "da") return da_lost_gone_access_warn(inputs)
	if (locale === "de") return de_lost_gone_access_warn(inputs)
	if (locale === "et") return et_lost_gone_access_warn(inputs)
	if (locale === "es") return es_lost_gone_access_warn(inputs)
	if (locale === "fr") return fr_lost_gone_access_warn(inputs)
	if (locale === "hr") return hr_lost_gone_access_warn(inputs)
	if (locale === "it") return it_lost_gone_access_warn(inputs)
	if (locale === "lv") return lv_lost_gone_access_warn(inputs)
	if (locale === "lt") return lt_lost_gone_access_warn(inputs)
	if (locale === "hu") return hu_lost_gone_access_warn(inputs)
	if (locale === "nl") return nl_lost_gone_access_warn(inputs)
	if (locale === "nb") return nb_lost_gone_access_warn(inputs)
	if (locale === "pl") return pl_lost_gone_access_warn(inputs)
	if (locale === "pt") return pt_lost_gone_access_warn(inputs)
	if (locale === "ro") return ro_lost_gone_access_warn(inputs)
	if (locale === "sk") return sk_lost_gone_access_warn(inputs)
	if (locale === "sl") return sl_lost_gone_access_warn(inputs)
	if (locale === "fi") return fi_lost_gone_access_warn(inputs)
	if (locale === "sv") return sv_lost_gone_access_warn(inputs)
	if (locale === "vi") return vi_lost_gone_access_warn(inputs)
	if (locale === "tr") return tr_lost_gone_access_warn(inputs)
	if (locale === "el") return el_lost_gone_access_warn(inputs)
	if (locale === "bg") return bg_lost_gone_access_warn(inputs)
	if (locale === "ru") return ru_lost_gone_access_warn(inputs)
	if (locale === "sr") return sr_lost_gone_access_warn(inputs)
	if (locale === "uk") return uk_lost_gone_access_warn(inputs)
	if (locale === "ka") return ka_lost_gone_access_warn(inputs)
	if (locale === "hi") return hi_lost_gone_access_warn(inputs)
	if (locale === "th") return th_lost_gone_access_warn(inputs)
	if (locale === "ko") return ko_lost_gone_access_warn(inputs)
	if (locale === "zh") return zh_lost_gone_access_warn(inputs)
	if (locale === "zh-tw") return zh_tw_lost_gone_access_warn(inputs)
	if (locale === "ja") return ja_lost_gone_access_warn(inputs)
	return en_lost_gone_access_warn(inputs)
});